import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import BlogosphereDetails from '../blogosphere-details';
import BlogosphereRateCard from '../blogosphere-rate-card';
import BlogosphereCollaborationTypes from '../blogosphere-collaborations-types';
import BlogosphereRawData from '../blogosphere-raw-data';
import BlogosphereBlogDetails from '../blogosphere-blog-details';

class InfluencerBlogosphere extends Component {

  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { influencerDetails: { blogosphereData } } = this.props;
    return (
      <div className="page-content">
        <Grid>
          <Grid.Row columns={2} equal>
            <Grid.Column>
              <BlogosphereDetails details={blogosphereData} />
            </Grid.Column>
            <Grid.Column>
              <BlogosphereRateCard details={blogosphereData} />
              <BlogosphereCollaborationTypes details={blogosphereData} />
              <BlogosphereBlogDetails details={blogosphereData} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <BlogosphereRawData details={blogosphereData} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

InfluencerBlogosphere.propTypes = {
  influencerDetails: PropTypes.object.isRequired,
};

export default InfluencerBlogosphere;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-blogosphere/index.js
 **/